import type { SubscriptionStatus } from '@/modules/subscriptions/types';

/** Row returned by GET /api/v1/admin/payments (snake_case). */
export interface AdminPaymentItem {
  payment_id: string;
  tenant_id: string;
  tenant_name: string;
  customer_name: string | null;
  customer_email: string | null;
  customer_phone: string | null;
  product_id: string;
  product_slug: string;
  product_name: string;
  plan_id: string;
  plan_name: string;
  subscription_id: string;
  subscription_status: SubscriptionStatus;
  entitlement_status: string | null;
  provider: string;
  provider_label: string;
  provider_payment_id: string | null;
  provider_invoice_id: string | null;
  status: string;
  amount: number;
  currency: string;
  fee_amount: number;
  net_amount: number;
  payment_intent_id: string | null;
  kind: string | null;
  created_at: string;
  updated_at: string;
  processed_at: string | null;
}

export interface AdminPaymentsListResponse {
  items: AdminPaymentItem[];
  next_cursor: string | null;
  total: number;
}

export interface ListAdminPaymentsQuery {
  status?: string;
  provider?: string;
  tenant_id?: string;
  product_id?: string;
  product_slug?: string;
  plan_id?: string;
  subscription_id?: string;
  search?: string;
  from?: string;
  to?: string;
  cursor?: string;
  limit?: number;
}

export const PAYMENT_PROVIDER_OPTIONS = [
  'myfatoorah',
  'instapay',
  'custom_gateway',
  'mock',
  'stripe',
] as const;

export type PaymentProviderOption = (typeof PAYMENT_PROVIDER_OPTIONS)[number];

export const PAYMENT_STATUS_OPTIONS = [
  'pending',
  'processing',
  'succeeded',
  'failed',
  'refunded',
  'partially_refunded',
] as const;
